import React from 'react';
import HelpCenterChatBox from '../../components/HelpCenter/HelpCenterChatBox';
import NavigationTopbar from '../../components/common/navigation/NavigationTopbar';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from '../../reducers/auth/authSlice';
import HelpCenterAdminChatBox from '../../components/HelpCenter/HelpCenterAdminChatBox';

export default function HelpCenter() {

  const currentLoginUser = useSelector(selectUser);

  return (
    <Box width={'100%'}>

      <NavigationTopbar />

      {
        currentLoginUser.email === process.env.REACT_APP_SUPPORT_TEAM_EMAIL 
          ?
          <HelpCenterAdminChatBox /> 
          :
          <HelpCenterChatBox /> 
      }

    </Box>
  );
}
